import { datadogRum, type RumEvent } from '@datadog/browser-rum';
import { nextjsPlugin } from '@datadog/browser-rum-nextjs';
import { env } from '@repo/platform-env';

const DATADOG_APP_ID = '6d656078-191a-4b89-84fb-82e2594b3d59';

datadogRum.init({
  applicationId: DATADOG_APP_ID,
  clientToken: env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
  site: 'datadoghq.com',
  enableExperimentalFeatures: ['feature_flags'],
  service: 'cardfinder-v2',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 5,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  traceSampleRate: 100,
  defaultPrivacyLevel: 'mask-user-input',
  env: env.NEXT_PUBLIC_DEPLOYABLE_ENV,
  version: env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  allowedTracingUrls: [
    /https:\/\/cardfinder-v2-pr-\d+\.vercel\.stage\.nerdwallet\.biz\//,
    (url: string) => url.startsWith('https://localnerd.stage.nerdwallet.biz'),
    (url: string) => url.startsWith(env.NEXT_PUBLIC_NW_URL),
    (url: string) => url.startsWith(env.NEXT_PUBLIC_SUPERGRAPH_URL),
    (url: string) => url.startsWith('https://siteusage.nerdwallet.com/v1'),
  ].map(matcher => ({
    match: matcher,
    propagatorTypes: ['tracecontext', 'datadog'],
  })),
  plugins: [nextjsPlugin()],
  beforeSend: (event: RumEvent) => {
    if (event.type === 'error') {
      // Ignores GTM errors if within the stack trace
      if (
        event.error.stack?.includes('googletagmanager') ||
        event.error.stack?.includes('tag-manager-measurement') ||
        event.error.stack?.includes('gtm.js')
      ) {
        return false;
      }
    }
    return true;
  },
});
